import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'
import { mapLanguageToComponentProps } from 'i18n'
import { Error } from './error'

const propTypes = {
  i18n: PropTypes.shape({
    error410: PropTypes.shape({
      heading: PropTypes.string,
      content: PropTypes.string,
    }).isRequired,
  }).isRequired,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
}

const defaultProps = {
  children: undefined,
}

export function Error410({ i18n, children }) {
  return (
    <Error heading={i18n.error410.heading} content={i18n.error410.content}>
      {children}
    </Error>
  )
}

Error410.propTypes = propTypes
Error410.defaultProps = defaultProps

export default connect(mapLanguageToComponentProps())(Error410)
